(() => {
  const getRoot = (element) => element.closest('[data-gift-option]');

  const updatePreview = (root, occasion) => {
    const radio = Array.from(root.querySelectorAll('input[type="radio"][data-front-image]'))
      .find((option) => option.value === occasion);
    const frontImage = root.querySelector('[data-gift-front-image]');

    if (radio && frontImage) {
      frontImage.src = radio.dataset.frontImage;
      frontImage.alt = `${occasion} gift card front`;
    }
  };

  const updatePropertyState = (root) => {
    const state = root.giftCardState;
    const giftToggle = root.querySelector('[data-gift-toggle]');
    const changeButton = root.querySelector('[data-gift-change]');
    const giftProperty = root.querySelector('[data-gift-property]');
    const occasionProperty = root.querySelector('[data-gift-occasion-property]');

    changeButton.disabled = !giftToggle.checked || !state.selectedOccasion;

    if (giftToggle.checked) {
      giftProperty.disabled = false;
      giftProperty.value = 'Yes';
      occasionProperty.disabled = !state.selectedOccasion;
      occasionProperty.value = state.selectedOccasion;
    } else {
      giftProperty.disabled = true;
      occasionProperty.disabled = true;
      occasionProperty.value = '';
    }
  };

  const saveGiftCardAttributes = (root) => {
    const state = root.giftCardState;
    const giftToggle = root.querySelector('[data-gift-toggle]');
    const attributes = giftToggle.checked && state.selectedOccasion
      ? {
          'Send as gift': 'Yes',
          'Gift occasion': state.selectedOccasion
        }
      : {
          'Send as gift': '',
          'Gift occasion': ''
        };

    return fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({ attributes })
    });
  };

  const closeModal = (root) => {
    const state = root.giftCardState;
    const modal = root.querySelector('[data-gift-modal]');
    state.pendingOccasion = state.selectedOccasion;

    root.querySelectorAll('input[type="radio"][data-front-image]').forEach((radio) => {
      radio.checked = radio.value === state.selectedOccasion;
    });
    updatePreview(root, state.selectedOccasion);

    modal.hidden = true;
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  const openModal = (root) => {
    const state = root.giftCardState;
    const modal = root.querySelector('[data-gift-modal]');
    state.pendingOccasion = state.selectedOccasion;

    root.querySelectorAll('input[type="radio"][data-front-image]').forEach((radio) => {
      radio.checked = radio.value === state.pendingOccasion;
    });
    updatePreview(root, state.pendingOccasion);

    modal.hidden = false;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };

  const initialize = (root) => {
    if (root.giftCardState) return;

    const selectedOccasion = root.dataset.selectedOccasion || '';
    root.giftCardState = {
      selectedOccasion,
      pendingOccasion: selectedOccasion
    };

    root.querySelectorAll('input[type="radio"][data-front-image]').forEach((radio) => {
      radio.checked = radio.value === selectedOccasion;
    });
    updatePreview(root, selectedOccasion);
    updatePropertyState(root);
  };

  document.addEventListener('click', (event) => {
    const root = getRoot(event.target);
    if (!root) return;
    initialize(root);

    if (event.target.closest('[data-gift-change]')) {
      openModal(root);
    } else if (event.target.closest('[data-gift-confirm]')) {
      const state = root.giftCardState;
      const errorElement = root.querySelector('[data-gift-error]');

      if (!state.pendingOccasion) {
        errorElement.hidden = false;
        return;
      }

      state.selectedOccasion = state.pendingOccasion;
      updatePropertyState(root);
      saveGiftCardAttributes(root);
      closeModal(root);
    } else if (event.target.closest('[data-gift-close]')) {
      closeModal(root);
    }
  });

  document.addEventListener('change', (event) => {
    const root = getRoot(event.target);
    if (!root) return;
    initialize(root);

    if (event.target.matches('[data-gift-toggle]')) {
      updatePropertyState(root);
      if (event.target.checked) {
        openModal(root);
      } else {
        saveGiftCardAttributes(root);
        closeModal(root);
      }
      return;
    }

    if (event.target.matches('input[type="radio"][data-front-image]')) {
      const state = root.giftCardState;
      state.pendingOccasion = event.target.value;
      updatePreview(root, state.pendingOccasion);
      root.querySelector('[data-gift-error]').hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-gift-modal]').forEach((modal) => {
      if (!modal.hidden) {
        const root = getRoot(modal);
        initialize(root);
        closeModal(root);
      }
    });
  });
})();
